import { InstallationCashFlowSummary } from "./InstallationCashFlowSummary";

export class BackOfficeCashFlowSummaryInstallation extends InstallationCashFlowSummary {
    cashiersBalance: number;
    refillsAmount: number;
    emptyBagAmount: number;
    depositedInBagAmount: number;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.CashiersBalance != null) this.cashiersBalance = obj.CashiersBalance;
        if (obj.RefillsAmount != null) this.refillsAmount = obj.RefillsAmount;
        if (obj.EmptyBagAmount != null) this.emptyBagAmount = obj.EmptyBagAmount;
        if (obj.DepositedInBagAmount != null) this.depositedInBagAmount = obj.DepositedInBagAmount;
    }
}
